<template>
  <div class="row m-0" id="inicio">
    <div class="col-12">
      <h1 v-if="response != 'Sem acesso'" class="title font-weight-bold text-uppercase">
        Alterar dados conta
      </h1>
      <h1 v-else class="title font-weight-bold text-uppercase">
        Criar conta Constr Pay
      </h1>
      <hr class="linha-amarela" />
      <div class="d-flex justify-content-end ">
        <b-button 
          class="mr-3" 
          variant="danger"
          @click="$refs.videoManual.toggleOpen({ 
            url: 'https://www.youtube.com/watch?v=fA9GvjTMgTE&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=20', 
            title: 'Minha conta' 
          })"
        >
          <i class="fas fa-play mr-1"></i>
          Ver video
        </b-button>
      </div>

    </div>
      <div v-if="response.message != null" class="card col-12 mb-4 mt-4">
        <div class="card-body">
          <form class="form-group row g-3">
            <div class="col-12 mb-4">
              <label for="price_range">Nome da conta</label>
              <input required v-model="name" class="form-control mb-3" id="name" placeholder="Nome da empresa" />
              <span>OBS: Nome da empresa que vai aparecer na fatura</span>
            </div>
            <div class="col-12">
              <label for="reply_to">E-mail para resposta dos clientes</label>
              <input required v-model="reply_to" class="form-control mb-3" id="reply_to" placeholder="E-mail para resposta dos clientes" />
            </div>
              <b-button @click="send()" class="col-12 mt-3 btn-success">Alterar dados da conta</b-button>
            </form>
          </div>
        </div>
        <div class="card col-12" v-if="response.message == null">
          <div class="card-body">
            <div>
              <label for="fantasia">Nome Fantasia:</label>
              <input v-model="fantasia" required id="fantasia" class="form-control" type="text">
              <br>
              <button @click="createSubAccount()" class="btn btn-success col-12">Criar conta</button>
            </div>
          </div>
      </div>        
      <VideoManual ref="videoManual"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import makeToast from '../../mixins/makeToast';
import scrollToElement from '../../mixins/scrollToElement';
import VideoManual from '@/components/VideoManual.vue';

// Terminar de validar e enviar os dados para a API.

export default {
  mixins: [scrollToElement],
  name: 'cotacao-pagamento',
  components: {
    VideoManual
  },
  data() {
    return {
      response: [],
      name: '',
      reply_to: '',
      fantasia: '',
      desativarComissao: false
    };
  },
  mixins: [makeToast],
  computed: {
    ...mapState({
      setValidation: (state) => state.setValidation,
    }),
    ...mapState(['dadosUsuario']),
  },

  mounted() {
    if(this.dadosUsuario.desativar_comissao && this.dadosUsuario.desativar_comissao) {
      this.desativarComissao = true;
    }

    this.getName();
    this.scrollToElement();
  },
  created() {
    this.showIugu();
  },
  methods: {
    getName(){
      if(!this.checkIsEmpty(this.dadosUsuario.informacoes.nome_fantasia)){
        this.fantasia = this.dadosUsuario.informacoes.nome_fantasia;
      }
    },
    createSubAccount() {
      const data = {
        id: this.dadosUsuario.id,
        name: this.fantasia,
        tipo_usuario_id: 3,
        comissao: this.desativarComissao
      };

      this.$store.dispatch('createSubAccount', data).then((resp) => {
        this.makeToast('Opa!', 'Conta criada com sucesso! Vamos redirecionar você para a validação', 'success');
        setTimeout(() => {
          this.$router.push({ name: 'lojista-iugu-validation' });
        }, 3500);
      });
    },
    showIugu() {
      this.$store.dispatch('showInfoDashboard')
        .then((resp) => {
          this.response = resp.data;

          if(this.response.message && this.response.message.name) {
            this.name = this.response.message.name
            this.reply_to = this.response.message.reply_to
          }
        })
        .catch((error) => {
          if (error.response.status === 500) {
            this.response = 'Sem acesso';
          }
        });
    },
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    unsMaskValor(valor) {
      return parseInt(String(valor).replace(/[\D]+/g, ''));
    },
    send() {
      const data = {
        name: this.name,
        reply_to: this.reply_to,
      };

      this.$store.dispatch('updateSubAcoount', data)
        .then((resp) => {
          this.makeToast('Opa!', 'Conta alterada com sucesso.', 'success');
        })
        .catch(() => {
          this.makeToast('Oops!', 'Aconteceu um erro. Tente novamente mais tarde', 'danger');
        });
    },
  },
};
</script>
